import { render, staticRenderFns } from "./fileOpenAlertModal.vue?vue&type=template&id=4afc58fe&"
import script from "./fileOpenAlertModal.vue?vue&type=script&lang=ts&"
export * from "./fileOpenAlertModal.vue?vue&type=script&lang=ts&"
import style0 from "./fileOpenAlertModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports